export const NGUOIDUNGKHO_LIST_INITING             = 'NGUOIDUNGKHO_LIST_INITING'
export const NGUOIDUNGKHO_LIST_REQUESTING          = 'NGUOIDUNGKHO_LIST_REQUESTING'
export const NGUOIDUNGKHO_LIST_SUCCESS             = 'NGUOIDUNGKHO_LIST_SUCCESS'
export const NGUOIDUNGKHO_LIST_ERROR               = 'NGUOIDUNGKHO_LIST_ERROR'   

export const NGUOIDUNGKHO_DETAIL_INITING           = 'NGUOIDUNGKHO_DETAIL_INITING'
export const NGUOIDUNGKHO_DETAIL_REQUESTING        = 'NGUOIDUNGKHO_DETAIL_REQUESTING'
export const NGUOIDUNGKHO_DETAIL_SUCCESS           = 'NGUOIDUNGKHO_DETAIL_SUCCESS'
export const NGUOIDUNGKHO_DETAIL_ERROR             = 'NGUOIDUNGKHO_DETAIL_ERROR'   

export const NGUOIDUNGKHO_UPDATE_REQUESTING        = 'NGUOIDUNGKHO_UPDATE_REQUESTING'
export const NGUOIDUNGKHO_UPDATE_SUCCESS           = 'NGUOIDUNGKHO_UPDATE_SUCCESS'
export const NGUOIDUNGKHO_UPDATE_ERROR             = 'NGUOIDUNGKHO_UPDATE_ERROR'   

export const NGUOIDUNGKHO_DETAIL_API               = '/api/v1/management/nguoidung_kho_list_by'  
export const NGUOIDUNGKHO_LIST_API                 = '/api/v1/management/kho_list_by_store'   
export const NGUOIDUNGKHO_UPDATE_API               = '/api/v1/management/nguoidung_kho_update_by_ids'  


// WEBPACK FOOTER //
// ./src/views/NguoiDungKho/constants.js